import { render } from "./BalanceActivityTable.vue?vue&type=template&id=a606e304&scoped=true"
import script from "./BalanceActivityTable.vue?vue&type=script&lang=js"
export * from "./BalanceActivityTable.vue?vue&type=script&lang=js"

import "./BalanceActivityTable.vue?vue&type=style&index=0&id=a606e304&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a606e304"]])

export default __exports__